// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 90%;
  max-width: 1280px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px 10px 24px;
 background: linear-gradient(135deg, #1e2023, #2b3038);

  backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 35px;
}

/* Logo */
.header .logo {
  height: 39px;
  object-fit: contain;
  margin-top: 3px;
}

/* Contenedor de botones */
.button-container {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.files-button,
.perfil-button,
.menu-button {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-family: 'Inter', 'Arial', sans-serif;
  padding: 8px 14px;
  background-color: rgba(255, 255, 255, 0.05);
  color: #f1f5f9;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.25s ease, transform 0.2s ease;
}

.files-button:hover,
.perfil-button:hover,
.menu-button:hover {
  background-color: rgba(255, 255, 255, 0.12);
  transform: scale(1.04);
}

.perfil-button-container {
  position: relative;
}

.button-text {
  font-size: 13px;
  white-space: nowrap;
}

.menu-button {
  padding: 6px px;
  font-size: 18px;
  background-color: rgba(255, 255, 255, 0.05);
  margin-right: 15px;
}

/* ✅ Versión Mobile */
@media (max-width: 768px) {
  .header {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
  }

  .header .logo {
    height: 36px;
  }

  .button-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }

  .files-button,
  .perfil-button,
  .menu-button {
    padding: 6px 10px;
    font-size: 13px;
    border-radius: 10px;
    white-space: nowrap;
  }

  .button-text {
    display: inline;
  }

  .menu-button {
    font-size: 16px;
    margin-right: 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/common/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;CAC7B,qDAAqD;;EAEpD,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yCAAyC;EACzC,iBAAiB;EACjB,2CAA2C;EAC3C,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sDAAsD;AACxD;;AAEA;;;EAGE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;;;IAGE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":[".header {\n  position: fixed;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  width: 90%;\n  max-width: 1280px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 24px 10px 24px;\n background: linear-gradient(135deg, #1e2023, #2b3038);\n\n  backdrop-filter: blur(14px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 35px;\n}\n\n/* Logo */\n.header .logo {\n  height: 39px;\n  object-fit: contain;\n  margin-top: 3px;\n}\n\n/* Contenedor de botones */\n.button-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-left: auto;\n}\n\n.files-button,\n.perfil-button,\n.menu-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  font-family: 'Inter', 'Arial', sans-serif;\n  padding: 8px 14px;\n  background-color: rgba(255, 255, 255, 0.05);\n  color: #f1f5f9;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 0.25s ease, transform 0.2s ease;\n}\n\n.files-button:hover,\n.perfil-button:hover,\n.menu-button:hover {\n  background-color: rgba(255, 255, 255, 0.12);\n  transform: scale(1.04);\n}\n\n.perfil-button-container {\n  position: relative;\n}\n\n.button-text {\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.menu-button {\n  padding: 6px px;\n  font-size: 18px;\n  background-color: rgba(255, 255, 255, 0.05);\n  margin-right: 15px;\n}\n\n/* ✅ Versión Mobile */\n@media (max-width: 768px) {\n  .header {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n  }\n\n  .header .logo {\n    height: 36px;\n  }\n\n  .button-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 8px;\n    margin-left: auto;\n  }\n\n  .files-button,\n  .perfil-button,\n  .menu-button {\n    padding: 6px 10px;\n    font-size: 13px;\n    border-radius: 10px;\n    white-space: nowrap;\n  }\n\n  .button-text {\n    display: inline;\n  }\n\n  .menu-button {\n    font-size: 16px;\n    margin-right: 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
